import { useThemeContext } from '@huggg/react-components';
import React from 'react';
import { Helmet } from 'react-helmet';

/**
 * Set the site favicon and mobile device icons.
 *
 * We use react-helmet to set the favicon meta tags as the generated HTML file
 * from react-build is not used, and we roll our own on sangria-server. Yet the
 * app should have control over the favicon, and not the server. This is a
 * suitable workaround. Every operator ships the same file set under its own
 * faviconPath; only the Safari mask icon is optional.
 */
const Favicon = () => {
  const { operator } = useThemeContext();
  const { faviconPath, maskIcon } = operator;

  return (
    <Helmet>
      <link rel="shortcut icon" href={`${faviconPath}/favicon.ico`} />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href={`${faviconPath}/apple-touch-icon.png`}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href={`${faviconPath}/favicon-32x32.png`}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href={`${faviconPath}/favicon-16x16.png`}
      />
      <link rel="manifest" href={`${faviconPath}/site.webmanifest`} />
      {maskIcon && (
        <link rel="mask-icon" href={maskIcon.href} color={maskIcon.color} />
      )}
      <meta name="msapplication-TileColor" content="#ffffff" />
      <meta name="theme-color" content="#ffffff" />
    </Helmet>
  );
};

export default Favicon;
